<template>
  <a-config-provider
    :theme="{
      algorithm: theme.defaultAlgorithm,
      token: {
        colorPrimary: '#10172A',
      },
    }"
  >
    <div class="flex min-h-screen flex-col bg-slate-200">
      <a
        href="#main-content"
        class="sr-only fixed left-4 top-4 z-[100] rounded-md bg-white px-4 py-2 text-slate-900 shadow-lg
          focus:not-sr-only"
      >
        Skip to main content
      </a>
      <div class="flex grow flex-col items-center justify-center">
        <main
          id="main-content"
          tabindex="-1"
          class="text-card-foreground m-8 w-5/6 max-w-6xl rounded-xl bg-white shadow-lg lg:min-h-[600px]"
          :class="authBg ? 'lg:grid lg:grid-cols-2' : 'flex flex-col m-8 lg:max-w-3xl'"
        >
          <div class="px-6 py-8 sm:px-10 md:px-12 lg:px-16">
            <nav class="flex w-full flex-wrap items-center justify-center lg:justify-start">
              <a
                v-if="logo"
                class="py-2 text-lg text-black hover:text-primary"
                href="/"
                aria-label="Home"
              >
                <img
                  class="h-12"
                  :src="logo"
                  alt=""
                >
              </a>
              <a
                v-else-if="!whitelabel"
                class="py-2 text-lg text-black hover:text-slate-700 lowercase"
                href="/"
                style="font-family: 'Montserrat Alternates', sans-serif;"
              >
                Rack Manage
              </a>
            </nav>
            <div class="flex size-full flex-col justify-center pb-8 pt-4">
              <router-view />
            </div>
          </div>
          <div
            v-if="authBg"
            class="hidden w-full overflow-hidden rounded-r-xl bg-slate-100 bg-cover bg-center bg-no-repeat lg:block"
            :style="{ backgroundImage: 'url(' + authBg + ')' }"
          />
        </main>
      </div>
      <footer-small />
    </div>
  </a-config-provider>
</template>
<script setup lang="ts">
import FooterSmall from '../components/Footers/FooterSmall.vue';
import loginBackground from '../assets/img/loginBackground.avif';
import { useStore } from '../api/index.ts';
import { theme } from 'ant-design-vue';

let authBg = loginBackground;
let logo = null;
let darklogo: string | null;

const store = useStore();

if (store.checkedDomain && store.checkedDomain.data && store.checkedDomain.data.background) {
  authBg = import.meta.env.VITE_CDN_URL + store.checkedDomain.data.background;
} else if (store.checkedDomain?.data && !store.checkedDomain.data.background) {
  authBg = '';
}

if (store.checkedDomain && store.checkedDomain.data && store.checkedDomain.data.logo) {
  logo = import.meta.env.VITE_CDN_URL + store.checkedDomain.data.logo;
}

if (store.checkedDomain && store.checkedDomain.data && store.checkedDomain.data.darklogo) {
  darklogo = import.meta.env.VITE_CDN_URL + store.checkedDomain.data.darklogo;
  if (!logo) {
    logo = darklogo;
  }
}

if (store.checkedDomain && store.checkedDomain.data && store.checkedDomain.data.favicon) {
  let link = document.querySelector<HTMLLinkElement>('link[rel~=\'icon\']');
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }
  link.href = import.meta.env.VITE_CDN_URL + store.checkedDomain.data.favicon;
}

const whitelabel =
  store.checkedDomain != null
  && store.checkedDomain.data
  && !store.checkedDomain.domain.endsWith(import.meta.env.VITE_HOSTNAME);
</script>
